<script>
  // @ is an alias to /src
  import ReportsList from '@/components/reports/list/Reports.vue'
  export default {
    name: 'home',
    components: {
      ReportsList
    }
  }
</script>

<template>
  <div class="reportsList">
    <!-- <h2 class="text-center pt-2 mb-4 pb-2" v-if="false">Lista raportów</h2> -->
    <ReportsList />
  </div>
</template>

<style lang="scss">
  .reportsList {
    padding: 0 0 70px 0;
  }
</style>
